import BaseResource from './index'
import LocationResource from './location'

export default class WaiverResource extends BaseResource {
    static endpoint = '/waivers'
    static related() {
        return {
            location: LocationResource
        }
    }

    static async outstanding() {
        const response = await this.wrap('/outstanding').get()
        const conneg = this.client.negotiateContent(this)
        const content = conneg(response)
        return content
    }

    async approve() {
        const response = await this.wrap('/approve').post()
        if (response.status == 200) {
            return new WaiverApprovalResource(response.data)
        }
    }

    async content() {
        const response = await this.wrap('/content').get()
        return response.data.html
    }
}

export class WaiverApprovalResource extends BaseResource {
    static endpoint = '/users/me/waivers/approved'
    static related() {
        return {
            waiver: WaiverResource
        }
    }
}
